module.exports = __webpack_public_path__ + "img/1484428621.08da2adc.jpg";